import PartnerBtnCN from '../Powerocean/components/PartnerBtnCN';
import BatteryExpandability from './components/BatteryExpandability';
import BatteryTechnology from './components/BatteryTechnology';
import BlackoutProtection from './components/BlackoutProtection';
import Disclaimer from './components/Disclaimer';
import FirstKV from './components/FirstKV';
import Nav from './components/Nav';
import PowerAnything from './components/PowerAnything';
import PowerHomes from './components/PowerHomes';
import ProductAnimation from './components/ProductAnimation';
import ProductIntroduction from './components/ProductIntroduction';
import ReliableQuality from './components/ReliableQuality';
import Solution from './components/Solution';

export default function IndexDynamic() {
    return (
        <>
            <Nav />
            <FirstKV />
            <ProductIntroduction />
            <ProductAnimation />
            <PowerAnything />
            <BlackoutProtection />
            <PowerHomes />
            <BatteryTechnology />
            <Solution />
            <BatteryExpandability />
            <ReliableQuality />
            <PartnerBtnCN />
            <Disclaimer />
        </>
    );
}
